var $ = jQuery;

export default class ShareButtons {

    ready() {

        $(document).on('click', '.js-btn-share', function () {
            $('.js-sharing-list').toggleClass('show');
            return false;
        });

    }
}